import React from 'react';
export function SolutionSection() {
  return <section className="py-12 bg-main overflow-hidden" data-id="element-206">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-207">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-208">
          <div data-id="element-209">
            <h2 className="text-3xl md:text-5xl font-serif mb-6 leading-tight text-title" data-id="element-210">
              Gana sin ser vista.
            </h2>
            <p className="text-body text-lg mb-4 leading-relaxed" data-id="element-211">
              Las cuentas que más crecen hoy no venden una persona. Venden una
              estética + una solución.
            </p>
            <p className="text-body text-lg mb-8 leading-relaxed" data-id="element-212">
              Sin mostrar tu cara, sin bailar y sin convertir tu vida privada en
              contenido.
            </p>
            <div className="p-6 bg-alt border-l-4 border-accent" data-id="element-213">
              <p className="font-serif text-lg italic text-title" data-id="element-214">
                "La era de vender tu vida privada terminó. Ahora gana quien
                tiene método."
              </p>
              <p className="mt-3 text-sm font-sans text-accent not-italic" data-id="element-215">
                — Método Faceless Spain
              </p>
            </div>

            <div className="mt-8" data-id="element-216">
              <p className="text-sm font-semibold text-title uppercase tracking-widest mb-4" data-id="element-217">
                Cómo funciona (en simple):
              </p>
              <ul className="space-y-3 text-body text-sm" data-id="element-218">
                <li className="flex items-start" data-id="element-219">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-220">
                    1.
                  </span>
                  <span data-id="element-221">Eliges una estética y un ángulo (sin exponerte)</span>
                </li>
                <li className="flex items-start" data-id="element-222">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-223">
                    2.
                  </span>
                  <span data-id="element-224">
                    Publicas contenido faceless (sin quedarte en blanco)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-225">
                  <span className="text-accent font-serif font-bold mr-3 mt-0.5" data-id="element-226">
                    3.
                  </span>
                  <span data-id="element-227">
                    Monetizas con una estructura clara (sin improvisar)
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative" data-id="element-228">
            <div className="space-y-8" data-id="element-229">
              <div className="bg-card p-8 border border-[#E7D8C8] relative" data-id="element-230">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-231">
                  01
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-232">
                  Anonimato es poder
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-233">
                  Construyes una marca que funciona sin depender de tu imagen.
                </p>
              </div>

              <div className="bg-card p-8 border border-[#E7D8C8] relative ml-4 md:ml-8" data-id="element-234">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-235">
                  02
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-236">
                  Contenido faceless (sin complicarte)
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-237">
                  Aprendes qué tipos de videos/fotos funcionan sin mostrar
                  rostro y cómo adaptarlos a tu estilo.
                </p>
              </div>

              <div className="bg-card p-8 border border-[#E7D8C8] relative ml-8 md:ml-16" data-id="element-238">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-239">
                  03
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-240">
                  Estructura que convierte
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-241">
                  Publicas con intención: perfil, mensajes y contenido alineados
                  para que la gente entienda y confíe.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}